import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputLabel from "@material-ui/core/InputLabel";
import { HTMLEditor, Trad } from "src/components";

interface THTMLEditorProps {
    Value: string;
    Label: string;
    Name: string;
    OnChange: (name: string, val: unknown) => void;
    OnlyOneTableAllowed?: boolean;
    OnChangeDerogation?: (e: React.FormEvent<any>) => void;
}

export const _HTMLEditor: React.FC<THTMLEditorProps> = ({ Name, Label, OnChange, Value, OnChangeDerogation, OnlyOneTableAllowed }) => {
    return (
        <>
            {OnChangeDerogation && <FormControlLabel control={<Checkbox onChange={OnChangeDerogation} name={Name} />} label={Trad.Trad(Label)} />}
            <InputLabel shrink>{Trad.Trad(Label)}</InputLabel>
            <HTMLEditor Name={Name} Value={Value} OnChange={OnChange} CampoWordMassimoUnaTabella={OnlyOneTableAllowed} />
        </>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/form/HTMLEditor.tsx